import { render } from "./NotInterestedView.vue?vue&type=template&id=f5c3c6a8"
import script from "./NotInterestedView.vue?vue&type=script&lang=js"
export * from "./NotInterestedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__